<div class="btn-group" role="tablist" aria-label="Configuracoes do relogio de ponto">
  <button
    type="button"
    class="btn"
    [class.btn-success]="aba === 'horarios'"
    [class.btn-outline-success]="aba !== 'horarios'"
    (click)="selecionar.emit('horarios')">
    Horarios
  </button>
  <button
    type="button"
    class="btn"
    [class.btn-success]="aba === 'jornadas'"
    [class.btn-outline-success]="aba !== 'jornadas'"
    (click)="selecionar.emit('jornadas')">
    Jornadas
  </button>
  <button
    type="button"
    class="btn"
    [class.btn-success]="aba === 'terminais'"
    [class.btn-outline-success]="aba !== 'terminais'"
    (click)="selecionar.emit('terminais')">
    Terminais
  </button>
</div>
